// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreUserSetupState from "@store/Framework/Store/Store/Pages/UserSetup/StoreUserSetupState";
import { MailChimpMemberInterestsModel, MailChimpMemberResponseModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: StoreUserSetupState = {
    isConfigured: false,
    memberInfo: {
        memberId: "",
        listId: "",
        isSubscribed: false,
        status: "",
        interests: [],
        reSubscribeUrl: "",
    },
};

const actions = {
    "Store/Pages/UserSetup/SetIsConfigured": (draft: Draft<StoreUserSetupState>, action: { isConfigured: boolean }) => {
        draft.isConfigured = action.isConfigured;
    },
    "Store/Pages/UserSetup/GetMemberInfo": (
        draft: Draft<StoreUserSetupState>,
        action: { memberInfo: MailChimpMemberInterestsModel },
    ) => {
        draft.memberInfo = action.memberInfo;
    },
    "Store/Pages/UserSetup/SetMemberInfo": (
        draft: Draft<StoreUserSetupState>,
        action: { response: MailChimpMemberResponseModel },
    ) => {
        draft.response = action.response;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreUserSetupActions = Parameters<typeof reducer>[1];
export default reducer;
